import { render } from "./ContentCollection.vue?vue&type=template&id=a24f11fc&scoped=true"
import script from "./ContentCollection.vue?vue&type=script&lang=js"
export * from "./ContentCollection.vue?vue&type=script&lang=js"

import "./ContentCollection.scss?vue&type=style&index=0&id=a24f11fc&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a24f11fc"]])

export default __exports__